module.exports = __webpack_public_path__ + "static/media/lora_co2_modbus_en.737ad772.md";